import {
  AppBar,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  makeStyles,
  Tab,
  TextField,
  Tabs,
  Typography,
  useTheme,
  useMediaQuery,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  Tooltip
} from '@material-ui/core';
import CachedIcon from '@material-ui/icons/Cached';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { green } from '@material-ui/core/colors';
import { STATUS_API } from 'src/app/constant/config';
import { FieldArray, Formik } from 'formik';
import * as Yup from 'yup';
import CustomDialog from 'src/app/components/CustomDialog';
import {
  controlSoundWarning,
  transmitActiveStatus,
  updateDevice,
  updateDeviceDisplayName,
  updateLicensePlate
} from 'src/features/deviceSlice';
import Switch from '@material-ui/core/Switch';
import AddIcon from '@material-ui/icons/Add';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import { getBusinessInfo } from 'src/features/userSlice';
import ModalConfirm from 'src/app/components/ModalConfirm';
import { vehicleType } from 'src/app/constant/vehicleType';

const createFuelCalibrationPoint = (percent = '', liters = '') => ({
  percent,
  liters
});

const buildFuelCalibrationPoints = device => {
  const oilMap = device?.oil_map || [];

  if (!oilMap.length) return [createFuelCalibrationPoint()];

  return oilMap.map(item => ({
    percent: item.l ?? '', // sensor value
    liters: item.v ?? ''
  }));
};

const CustomSwitchWithText = ({ checked, ...props }) => {
  const classes = useStyles();
  return (
    <Box className={classes.customSwitchContainer}>
      <span className={`${classes.switchText} ${classes.switchTextOff}`}>
        Tắt
      </span>
      <Switch
        checked={checked}
        classes={{
          root: classes.customSwitchRoot,
          switchBase: classes.customSwitchBase,
          thumb: classes.customSwitchThumb,
          track: classes.customSwitchTrack,
          checked: classes.customSwitchChecked
        }}
        {...props}
      />
      <span className={`${classes.switchText} ${classes.switchTextOn}`}>
        Bật
      </span>
    </Box>
  );
};

const isTransmissionEnabled = statusTransmission =>
  Number(statusTransmission) === 1;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`edit-device-tabpanel-${index}`}
      aria-labelledby={`edit-device-tab-${index}`}
      {...other}
    >
      {value === index && <Box pt={3}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `edit-device-tab-${index}`,
    'aria-controls': `edit-device-tabpanel-${index}`
  };
}

function EditVersionModal({ open, onClose, device, fetchDetail }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const statusCreate = useSelector(state => state.staffSlice.statusCreate);
  const detailVehicle = useSelector(state => state.vehicleSlice.detailVehicle);

  const isAdmin = useSelector(state => state.authSlice.isAdmin);
  const isAgency = useSelector(state => state.authSlice.isAgency);
  const isTechnical = useSelector(state => state.authSlice.isTechnical);

  const formikRef = useRef();

  const listAgencyBusiness = useSelector(
    state => state.agencySlice.listAgencyBusiness
  );
  const [isTransmit, setIsTransmit] = useState(
    isTransmissionEnabled(device?.status_transmission)
  );
  const [useSuggestedName, setUseSuggestedName] = useState(
    device?.is_display_name || false
  );
  const [configAlert, setConfigAlert] = useState(
    device?.is_turn_on_sound || false
  );
  const [tabValue, setTabValue] = useState(0);

  const [openConfirm, setOpenConfirm] = useState(false);
  const [nextValue, setNextValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const [oilType, setOilType] = useState(
    device.oil_type === false ? 'pulse' : 'percent'
  );
  const [currentLicensePlate, setCurrentLicensePlate] = useState(
    device?.vehicle?.license_plate || ''
  );
  const [isInfoTransmit, setIsInfoTransmit] = useState(false);
  const [deviceTypeDetail, setDeviceTypeDetail] = useState({});
  const [selectedTonnage, setSelectedTonnage] = useState([]);
  const [selectedSlots, setSelectedSlots] = useState([]);
  const [isCommitmentChecked, setIsCommitmentChecked] = useState(false);

  const vehicleTitle = device?.vehicle?.vehicle_type?.title || '';

  useEffect(() => {
    const target = vehicleType.find(type => type.name === vehicleTitle);
    if (target) {
      setDeviceTypeDetail(target);
      setSelectedSlots(target?.slots);
      setSelectedTonnage(target?.tonnage);
    } else {
      setDeviceTypeDetail({});
      setSelectedSlots([]);
      setSelectedTonnage([]);
    }
  }, []);

  const isCarType =
    device?.deviceType?.name === 'VGPS_CAR4G' ||
      device?.deviceType?.name === 'VGPS_2CAM' ||
      device?.deviceType?.name === 'VGPS_4CAM'
      ? true
      : false;

  useEffect(() => {
    setIsTransmit(isTransmissionEnabled(device?.status_transmission));
    setUseSuggestedName(device?.is_display_name || false);
    setConfigAlert(device?.is_turn_on_sound || false);
    setCurrentLicensePlate(device?.vehicle?.license_plate || '');
    setIsInfoTransmit(false);
    setIsCommitmentChecked(false);
    setTabValue(0);
  }, [device, open]);
  // Tich truyen
  const handleChangeSwitch = event => {
    const isTransmit = event.target.checked ? 1 : 0;
    const selectedPhone = device?.end_user?.user.phone
      ? device?.end_user?.user.phone
      : null;
    if (isTransmit === 1 && selectedPhone) {
      dispatch(getBusinessInfo({ phone: selectedPhone }));
    }
    dispatch(
      transmitActiveStatus({ id: device.id, data: { status: isTransmit } })
    );
    setIsTransmit(event.target.checked);
  };

  //Change license plate
  const handleChangeLicensePlate = values => {
    setTimeout(async () => {
      try {
        await dispatch(
          updateLicensePlate({
            id: device?.id,
            data: {
              license_plate: values.new_license_plate?.trim() || ''
            }
          })
        );

        onClose();
      } catch (error) {
        console.error(error);
      }
    }, 1000);
  };

  // Suggested name base on license plate
  const handleChangeSuggestedName = async values => {
    const newName = values.name?.trim();
    await dispatch(
      updateDeviceDisplayName({
        id: device.id,
        data: {
          name: newName,
          enable: Boolean(newName)
        }
      })
    );
    onClose();
  };

  const confirmSwap = async e => {
    setUseSuggestedName(e.target.checked);
    await dispatch(
      updateDeviceDisplayName({
        id: device.id,
        data: {
          enable: false
        }
      })
    );
  };

  // Control sound alert
  const onConfirmSound = async () => {
    try {
      setLoading(true);

      const deviceId = device.id;
      const controlSoundReq = nextValue ? 0 : 1;

      await dispatch(
        controlSoundWarning({
          id: deviceId,
          data: { status: controlSoundReq }
        })
      ).unwrap();

      setConfigAlert(nextValue);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      setOpenConfirm(false);
    }
  };

  const onToggleSound = e => {
    if (loading) return;
    setNextValue(e.target.checked);
    setOpenConfirm(true);
  };

  // Update device
  const handleSubmit = data => {
    if (tabValue === 2 && isTransmit && !isCommitmentChecked) {
      return;
    }

    if (tabValue === 0) {
      if (data.license_plate !== currentLicensePlate) {
        handleChangeLicensePlate({ new_license_plate: data.license_plate });
      }

      if (useSuggestedName) {
        handleChangeSuggestedName({ name: data.name });
      }
    }

    const oil_map = data.fuel_calibration_points
      .filter(p => p.percent !== '' && p.liters !== '')
      .map(p => ({
        l: Number(p.percent),
        v: Number(p.liters)
      }));

    const newData = {
      vehicle_license_plate: '',
      title_device_type: data.vehicle_type,
      slots: data.slots || null,
      tonnage: data.tonnage || null,
      name_of_user_for_gps: null,
      version: data.version,
      sim_phone: data.sim_phone,

      business_id: isTransmit && data?.business_id ? data.business_id : null,
      passenger_capacity:
        isTransmit && data?.passenger_capacity
          ? Number(data.passenger_capacity)
          : null,
      tax_code: isTransmit && data?.tax_code ? data.tax_code : null,
      max_payload:
        isTransmit && data?.max_payload ? Number(data.max_payload) : null,
      transport_operator:
        isTransmit && data?.business_name ? data.business_name : null,
      chassis_number:
        isTransmit && data?.chassis_number ? data?.chassis_number : null,
      oil_type: data?.fuelSensorType === 'percent' ? 1 : 0,
      oil_map: oil_map.length > 0 ? oil_map : null
    };

    dispatch(
      updateDevice({
        data: newData,
        id: device.id
      })
    );

    onClose();
  };

  const handleClose = () => {
    setIsTransmit(isTransmissionEnabled(device?.status_transmission));
    setUseSuggestedName(device?.is_display_name || false);
    setCurrentLicensePlate(device?.vehicle?.license_plate || '');
    setConfigAlert(device?.is_turn_on_sound || false);
    setIsInfoTransmit(false);
    setIsCommitmentChecked(false);
    setTabValue(0);
    onClose();
  };

  useEffect(() => {
    if (!formikRef.current) return;

    if (isInfoTransmit) {
      formikRef.current.setValues(prev => ({
        ...prev,
        business_name: device?.transport_operator || '',
        tax_code: device?.tax_code || '',
        business_id: device?.business?.id || ''
      }));
    } else {
      formikRef.current.setValues(prev => ({
        ...prev,
        business_name: '',
        tax_code: '',
        business_id: ''
      }));
    }
  }, [isInfoTransmit]);

  const handleSetInfoTransmit = e => {
    const checked = e.target.checked;
    setIsInfoTransmit(checked);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleFuelSensorTypeChange = useCallback(
    (newType, setFieldValue) => {
      const initialOilType = device?.oil_type ? 'percent' : 'pulse';

      setFieldValue('fuelSensorType', newType);

      const isSameAsBE = newType === initialOilType;

      setOilType(newType);

      if (isSameAsBE) {
        setFieldValue(
          'fuel_calibration_points',
          buildFuelCalibrationPoints(device)
        );
      } else {
        setFieldValue('fuel_calibration_points', [
          createFuelCalibrationPoint()
        ]);
      }
    },
    [device]
  );

  const titleControlSound = 'Chú ý';
  const contentControlSound = configAlert
    ? 'Bạn chỉ nên tắt âm thanh cảnh báo trong quá trình thử nghiệm! Bạn có chắc chắn muốn tắt âm thanh không?'
    : 'Bạn có chắc chắn muốn bật âm thanh cảnh báo không?';
  const shouldValidateFuelCalibration =
    tabValue === 1 && isCarType && (isAdmin || isAgency || isTechnical);

  const handleSelectVehicle = (e, value, setFieldValue) => {
    const target = vehicleType.find(type => {
      return type.id === Number(value.id);
    });
    if (target) {
      setDeviceTypeDetail(target);
      setSelectedSlots(target?.slots);
      setSelectedTonnage(target?.tonnage);

      setFieldValue('vehicle_type', target.name);
    }
  };

  const handleRefresh = () => {
    if (device && device.id) {
      fetchDetail(device.id);
    }
  }

  return (
    <>
      <ModalConfirm
        title={titleControlSound}
        content={contentControlSound}
        textOk={'Đồng ý'}
        textCancel={'Hủy'}
        open={openConfirm}
        setOpen={setOpenConfirm}
        callbackOk={onConfirmSound}
      />

      <CustomDialog title="Cấu hình thiết bị" open={open} onClose={handleClose}>
        <div>
          <AppBar position="static" elevation={0} className={classes.appBar}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              variant={isMobile ? 'scrollable' : 'fullWidth'}
              scrollButtons={isMobile ? 'auto' : 'off'}
              aria-label="device configuration tabs"
              className={classes.tabs}
            >
              <Tab label="Cấu hình thiết bị" {...a11yProps(0)} />
              <Tab label="Cấu hình cảm biến xăng dầu" {...a11yProps(1)} />
              <Tab label="Cấu hình tích truyền" {...a11yProps(2)} />
            </Tabs>
          </AppBar>

          <Formik
            innerRef={formikRef}
            initialValues={{
              serial: device?.serial || '',
              name: device?.name || '',
              license_plate: device?.vehicle?.license_plate || '',
              version: device?.hardware_version || '',
              sim_phone: device?.sim || '',
              vehicle_type: device?.vehicle?.vehicle_type?.title || '',
              fuel_calibration_points: buildFuelCalibrationPoints(device),

              business_name: device?.transport_operator || '',
              tax_code: device?.tax_code || '',
              business_id: device?.business?.id || '',
              passenger_capacity: device?.passenger_capacity || '',
              max_payload: device?.max_payload || '',
              chassis_number: device?.chassis_number || '',

              fuelSensorType: device?.oil_type ? 'percent' : 'pulse',
              tonnage: device?.vehicle?.vehicle_type?.tonnage || '',
              slots: device?.vehicle?.vehicle_type?.slots || ''
            }}
            enableReinitialize={true}
            validationSchema={values =>
              Yup.object().shape({
                business_name: tabValue === 2 && isTransmit
                  ? Yup.string()
                    .trim()
                    .required(
                      'Tên đơn vị kinh doanh không được để trống'
                    )
                  : Yup.string().notRequired(),
                tax_code: tabValue === 2 && isTransmit
                  ? Yup.string()
                    .trim()
                    .required('Mã số thuế không được để trống')
                  : Yup.string().notRequired(),
                business_id: tabValue === 2 && isTransmit
                  ? Yup.string().required(
                    'Loại hình kinh doanh không được để trống'
                  )
                  : Yup.string().notRequired(),

                fuel_calibration_points: shouldValidateFuelCalibration
                  ? Yup.array()
                    .of(
                      Yup.object().shape({
                        percent: Yup.number()
                          .required('Vui lòng nhập giá trị cảm biến')
                          .min(0, 'Giá trị không hợp lệ')
                          .when('$fuelSensorType', (fuelSensorType, schema) =>
                            oilType === 'pulse'
                              ? schema.max(4095, 'Giá trị tối đa là 4095')
                              : schema.max(100, 'Giá trị tối đa là 100%')
                          ),
                        liters: Yup.number()
                          .required('Vui lòng nhập dung tích')
                          .min(0, 'Dung tích không hợp lệ')
                      })
                    )
                    .test(
                      'min-2-pairs',
                      'Vui lòng cấu hình ít nhất 2 cặp giá trị',
                      value => !value || value.length === 0 || value.length >= 2
                    )
                  : Yup.array().notRequired()
              })
            }
            onSubmit={handleSubmit}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              touched,
              values,
              setFieldValue
            }) => (
              <form onSubmit={handleSubmit}>
                <TabPanel value={tabValue} index={0}>
                  <Grid container spacing={3}>
                    <Grid item md={4} xs={12}>
                      <InputLabel>
                        Serial thiết bị <span style={{ color: 'red' }}></span>
                      </InputLabel>
                      <TextField
                        error={Boolean(touched.email && errors.email)}
                        fullWidth
                        disabled={true}
                        helperText={touched.email && errors.email}
                        margin="normal"
                        className="input-no-fieldset"
                        name="email"
                        size="small"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.serial}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item md={4} xs={12}>
                      <InputLabel>
                        Phiên bản hardware<span style={{ color: 'red' }}></span>
                      </InputLabel>
                      <TextField
                        className="input-no-fieldset"
                        fullWidth
                        disabled
                        margin="normal"
                        name="version"
                        size="small"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.version}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item md={4} xs={12}>
                      <InputLabel style={{ marginBottom: '21px' }}>
                        Loại phương tiện<span style={{ color: 'red' }}></span>
                      </InputLabel>
                      <Autocomplete
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        size="small"
                        options={vehicleType || []}
                        getOptionLabel={option => option.name}
                        value={(vehicleType || []).find(
                          option => option.name === values.vehicle_type
                        )}
                        onChange={(e, value) =>
                          handleSelectVehicle(e, value, setFieldValue)
                        }
                        disableClearable
                        renderInput={params => (
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder="Chọn loại phương tiện"
                            name="vehicle_type"
                            InputProps={{
                              ...params.InputProps,
                              style: {
                                fontSize: '16px',
                                padding: '0 8px',
                                height: '35px'
                              }
                            }}
                          />
                        )}
                        className={classes.customOutline}
                      />
                    </Grid>

                    <Grid item md={4} xs={12}>
                      <InputLabel>
                        Biển số hiện tại<span style={{ color: 'red' }}></span>
                      </InputLabel>
                      <TextField
                        className="input-no-fieldset"
                        fullWidth
                        disabled={true}
                        margin="normal"
                        size="small"
                        value={currentLicensePlate}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item md={4} xs={12}>
                      <InputLabel>
                        Biển số mới<span style={{ color: 'red' }}></span>
                      </InputLabel>
                      <TextField
                        error={Boolean(
                          touched.license_plate && errors.license_plate
                        )}
                        className="input-no-fieldset"
                        fullWidth
                        helperText={
                          touched.license_plate && errors.license_plate
                        }
                        margin="normal"
                        name="license_plate"
                        size="small"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item md={4} xs={12}>
                      <InputLabel>
                        Số sim thiết bị<span style={{ color: 'red' }}></span>
                      </InputLabel>
                      <TextField
                        error={Boolean(touched.sim_phone && errors.sim_phone)}
                        className="input-no-fieldset"
                        fullWidth
                        helperText={touched.sim_phone && errors.sim_phone}
                        margin="normal"
                        name="sim_phone"
                        size="small"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.sim_phone}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid
                      item
                      md={4}
                      xs={12}
                      style={{ display: 'flex', alignItems: 'center' }}
                    >
                      <InputLabel className={classes.switchLabel}>
                        Sử dụng tên gợi nhớ{' '}
                        <span className="text-danger"></span>
                      </InputLabel>
                      <Switch
                        checked={useSuggestedName}
                        onChange={confirmSwap}
                        name="useSuggestedName"
                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                      />
                    </Grid>

                    <Grid item md={4} xs={12}>
                      <TextField
                        className="input-no-fieldset"
                        fullWidth
                        disabled={useSuggestedName ? false : true}
                        margin="normal"
                        name="name"
                        size="small"
                        placeholder="Nhập tên gợi nhớ..."
                        value={values.name}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        variant="outlined"
                      />
                    </Grid>

                    {isCarType && (
                      <Grid
                        item
                        md={4}
                        xs={12}
                        style={{ display: 'flex', alignItems: 'center' }}
                      >
                        <InputLabel className={classes.switchLabel}>
                          Cấu hình âm thanh Buzzer{' '}
                          <span className="text-danger"></span>
                        </InputLabel>
                        <CustomSwitchWithText
                          checked={configAlert}
                          onChange={onToggleSound}
                          name="configAlert"
                          disabled={loading}
                        />
                      </Grid>
                    )}

                    {(deviceTypeDetail.id === 4) && (
                      <Grid item md={4} xs={12}>
                        <Autocomplete
                          size="small"
                          options={selectedSlots ?? []}
                          getOptionLabel={option => option?.name || ''}
                          value={
                            selectedSlots?.find(
                              item => item.value === values.slots
                            ) || null
                          }
                          isOptionEqualToValue={(option, value) =>
                            option?.value === value?.value
                          }
                          onChange={(e, value) => {
                            setFieldValue('slots', value?.value || '');
                          }}
                          renderInput={params => (
                            <TextField
                              {...params}
                              className="input-no-fieldset"
                              variant="outlined"
                              margin="normal"
                              name="slots"
                              placeholder="Chọn số chỗ"
                              onBlur={handleBlur}
                              error={touched.slots && Boolean(errors.slots)}
                              helperText={touched.slots && errors.slots}
                            />
                          )}
                        />
                      </Grid>
                    )}

                    {(deviceTypeDetail.id === 6) && (
                      <Grid item md={4} xs={12}>
                        <Autocomplete
                          size="small"
                          options={selectedTonnage || []}
                          getOptionLabel={option => option?.name || ''}
                          value={
                            (selectedTonnage || []).find(
                              item => item.value === values.tonnage
                            ) || null
                          }
                          isOptionEqualToValue={(option, value) => option.id === value.id}
                          onChange={(e, value) => {
                            setFieldValue('tonnage', value?.value || '');
                          }}
                          renderInput={params => (
                            <TextField
                              {...params}
                              className="input-no-fieldset"
                              variant="outlined"
                              margin="normal"
                              name="tonnage"
                              placeholder="Chọn tải trọng"
                              onBlur={handleBlur}
                              error={touched.tonnage && Boolean(errors.tonnage)}
                              helperText={touched.tonnage && errors.tonnage}
                            />
                          )}
                        />
                      </Grid>
                    )}

                  </Grid>
                </TabPanel>
                {
                  <TabPanel value={tabValue} index={1}>
                    {isAdmin || isAgency || isTechnical ? (
                      <Grid container spacing={3}>
                        {isCarType ? (
                          <>
                            <Grid item xs={12}>
                              <Box className={classes.fuelSensorPanel}>
                                <Typography className={classes.fuelSensorTitle}>
                                  Cấu hình mức nhiên liệu (L - V)
                                </Typography>
                                <Box
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                  }}
                                >
                                  <FormControl
                                    component="fieldset"
                                    style={{ paddingBottom: '10px' }}
                                  >
                                    <RadioGroup
                                      row
                                      name="fuelSensorType"
                                      value={values.fuelSensorType}
                                      onChange={e =>
                                        handleFuelSensorTypeChange(
                                          e.target.value,
                                          setFieldValue
                                        )
                                      }
                                    >
                                      <FormControlLabel
                                        value="pulse"
                                        control={<Radio />}
                                        label="Xung (0 - 4095)"
                                      />
                                      <FormControlLabel
                                        value="percent"
                                        control={<Radio />}
                                        label="Phần trăm (0 - 100%)"
                                      />
                                    </RadioGroup>
                                  </FormControl>

                                  <Box
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      marginRight: '34px'
                                    }}
                                  >
                                    <Typography style={{ paddingLeft: '60px' }}>
                                      {`Giá trị cảm biến nhiên liệu: ${detailVehicle?.oil_level ?? '--'}`}
                                    </Typography>
                                    <Tooltip title="Làm mới">
                                      <IconButton
                                        onClick={handleRefresh}
                                        style={{ color: '#d9042f' }}
                                      >
                                        <CachedIcon />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                </Box>

                                <FieldArray name="fuel_calibration_points">
                                  {({ push, remove }) => (
                                    <>
                                      {values.fuel_calibration_points.map(
                                        (point, index) => (
                                          <Box
                                            key={`fuel-calibration-${index}`}
                                            className={
                                              classes.fuelCalibrationRow
                                            }
                                            style={{ alignItems: 'flex-start' }}
                                          >
                                            <TextField
                                              className={
                                                classes.fuelCalibrationInput
                                              }
                                              name={`fuel_calibration_points.${index}.percent`}
                                              size="small"
                                              placeholder={'Giá trị cảm biến'}
                                              onBlur={handleBlur}
                                              onChange={handleChange}
                                              value={point.percent}
                                              variant="outlined"
                                              type="number"
                                              error={Boolean(
                                                touched
                                                  .fuel_calibration_points?.[
                                                  index
                                                ]?.percent &&
                                                errors
                                                  .fuel_calibration_points?.[
                                                  index
                                                ]?.percent
                                              )}
                                              helperText={
                                                (touched
                                                  .fuel_calibration_points?.[
                                                  index
                                                ]?.percent &&
                                                  errors
                                                    .fuel_calibration_points?.[
                                                    index
                                                  ]?.percent) ||
                                                ' ' // ← space giữ chỗ
                                              }
                                              inputProps={{
                                                min: 0,
                                                max:
                                                  values.fuelSensorType ===
                                                    'pulse'
                                                    ? 4095
                                                    : 100
                                              }}
                                              InputProps={{
                                                endAdornment: (
                                                  <InputAdornment position="end">
                                                    {values.fuelSensorType ===
                                                      'pulse'
                                                      ? ''
                                                      : '%'}
                                                  </InputAdornment>
                                                )
                                              }}
                                            />

                                            <TextField
                                              className={
                                                classes.fuelCalibrationInput
                                              }
                                              name={`fuel_calibration_points.${index}.liters`}
                                              size="small"
                                              placeholder="Dung tích"
                                              onBlur={handleBlur}
                                              onChange={handleChange}
                                              value={point.liters}
                                              variant="outlined"
                                              error={Boolean(
                                                touched
                                                  .fuel_calibration_points?.[
                                                  index
                                                ]?.liters &&
                                                errors
                                                  .fuel_calibration_points?.[
                                                  index
                                                ]?.liters
                                              )}
                                              helperText={
                                                (touched
                                                  .fuel_calibration_points?.[
                                                  index
                                                ]?.liters &&
                                                  errors
                                                    .fuel_calibration_points?.[
                                                    index
                                                  ]?.liters) ||
                                                ' '
                                              }
                                              InputProps={{
                                                endAdornment: (
                                                  <InputAdornment position="end">
                                                    Lít
                                                  </InputAdornment>
                                                )
                                              }}
                                            />

                                            <IconButton
                                              className={
                                                classes.removeCalibrationButton
                                              }
                                              onClick={() => remove(index)}
                                              size="small"
                                              type="button"
                                            >
                                              <RemoveCircleOutlineIcon />
                                            </IconButton>
                                          </Box>
                                        )
                                      )}

                                      <Button
                                        variant="outlined"
                                        fullWidth
                                        type="button"
                                        onClick={() =>
                                          push(createFuelCalibrationPoint())
                                        }
                                        className={classes.addCalibrationButton}
                                        startIcon={<AddIcon />}
                                      >
                                        Thêm mức nhiên liệu
                                      </Button>
                                    </>
                                  )}
                                </FieldArray>

                                {typeof errors.fuel_calibration_points === 'string' && (
                                  <Typography
                                    color="error"
                                    variant="caption"
                                    style={{ display: 'block', marginTop: 8 }}
                                  >
                                    {errors.fuel_calibration_points}
                                  </Typography>
                                )}

                                <Box className={classes.sensorHint}>
                                  (L: Giá trị cảm biến do thiết bị gửi lên, V:
                                  Dung tích thực của bình)
                                </Box>
                              </Box>
                            </Grid>
                          </>
                        ) : (
                          <Grid item xs={12}>
                            <Typography
                              variant="body2"
                              color="textSecondary"
                              className={classes.emptyTabText}
                            >
                              Thiết bị này không hỗ trợ cấu hình cảm biến xăng
                              dầu.
                            </Typography>
                          </Grid>
                        )}
                      </Grid>
                    ) : (
                      <Grid item xs={12}>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          className={classes.emptyTabText}
                        >
                          Vui lòng liên hệ với bộ phận kĩ thuật để được hỗ trợ
                          cấu hình cảm biến xăng dầu
                        </Typography>
                      </Grid>
                    )}
                  </TabPanel>
                }

                <TabPanel value={tabValue} index={2}>
                  {device?.deviceType?.name === 'VGPS_CAR4G' ? (
                    <Grid container spacing={3}>
                      <Grid
                        item
                        md={4}
                        xs={12}
                        style={{ display: 'flex', alignItems: 'center' }}
                      >
                        <InputLabel className={classes.switchLabel}>
                          Tích truyền QCVN 06:2024/BCA{' '}
                          <span className="text-danger"></span>
                        </InputLabel>
                        <Switch
                          checked={isTransmit}
                          onChange={handleChangeSwitch}
                          name="isTransmit"
                          inputProps={{ 'aria-label': 'secondary checkbox' }}
                        />
                      </Grid>

                      {isTransmit && (
                        <>
                          <Grid
                            item
                            md={8}
                            xs={12}
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            <InputLabel className={classes.switchLabel}>
                              Lấy thông tin từ tài khoản{' '}
                              <span className="text-danger"></span>
                            </InputLabel>
                            <Switch
                              checked={isInfoTransmit}
                              onChange={handleSetInfoTransmit}
                              name="isTransmit"
                              inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel>
                              Tên đơn vị kinh doanh vận tải{' '}
                              <span className="text-danger">*</span>
                            </InputLabel>
                            <TextField
                              disabled={isInfoTransmit ? true : false}
                              error={Boolean(
                                touched.business_name && errors.business_name
                              )}
                              size="small"
                              className="input-no-fieldset"
                              fullWidth
                              helperText={
                                touched.business_name && errors.business_name
                              }
                              margin="normal"
                              name="business_name"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.business_name || ''}
                              variant="outlined"
                            />
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel>
                              Mã số thuế{' '}<span className="text-danger">*</span>
                            </InputLabel>
                            <TextField
                              disabled={isInfoTransmit ? true : false}
                              error={Boolean(touched.tax_code && errors.tax_code)}
                              size="small"
                              className="input-no-fieldset"
                              fullWidth
                              helperText={touched.tax_code && errors.tax_code}
                              margin="normal"
                              name="tax_code"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.tax_code || ''}
                              variant="outlined"
                            />
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel style={{ marginBottom: '21px' }}>
                              Loại hình kinh doanh vận tải{' '}
                              <span style={{ color: 'red' }}>*</span>
                            </InputLabel>
                            <Autocomplete
                              disabled={isInfoTransmit ? true : false}
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              size="small"
                              options={listAgencyBusiness || []}
                              getOptionLabel={option => option.title}
                              value={(listAgencyBusiness || []).find(
                                option =>
                                  Number(option.id) === Number(values.business_id)
                              )}
                              onChange={(e, value) =>
                                setFieldValue('business_id', value?.id || '')
                              }
                              disableClearable
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  placeholder="Chọn loại hình kinh doanh"
                                  name="business_id"
                                  error={Boolean(
                                    touched.business_id && errors.business_id
                                  )}
                                  helperText={
                                    touched.business_id && errors.business_id
                                  }
                                  InputProps={{
                                    ...params.InputProps,
                                    style: {
                                      fontSize: '16px',
                                      padding: '0 8px',
                                      height: '35px'
                                    }
                                  }}
                                />
                              )}
                              className={classes.customOutline}
                            />
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel>
                              Số khung <span className="text-danger"></span>
                            </InputLabel>
                            <TextField
                              size="small"
                              className="input-no-fieldset"
                              fullWidth
                              margin="normal"
                              name="chassis_number"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.chassis_number || ''}
                              variant="outlined"
                            />
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel>
                              Số người chuyên chở{' '}
                              <span className="text-danger"></span>
                            </InputLabel>
                            <TextField
                              size="small"
                              className="input-no-fieldset"
                              fullWidth
                              margin="normal"
                              name="passenger_capacity"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.passenger_capacity || ''}
                              variant="outlined"
                            />
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel>
                              Tải trọng xe (kg){' '}
                              <span className="text-danger"></span>
                            </InputLabel>
                            <TextField
                              size="small"
                              className="input-no-fieldset"
                              fullWidth
                              margin="normal"
                              name="max_payload"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.max_payload || ''}
                              variant="outlined"
                            />
                          </Grid>
                        </>
                      )}
                    </Grid>
                  ) : (
                    <Grid item xs={12}>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        className={classes.emptyTabText}
                      >
                        Thiết bị này không hỗ trợ tích truyền QCVN 06:2024/BCA
                      </Typography>
                    </Grid>
                  )}
                </TabPanel>

                <Box my={3}>
                  {tabValue === 2 && isTransmit && (
                    <Box className={classes.commitmentBox}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isCommitmentChecked}
                            onChange={e =>
                              setIsCommitmentChecked(e.target.checked)
                            }
                            color="primary"
                          />
                        }
                        label="Tôi cam kết các thông tin khai báo là chính xác. Nếu có sai lệch tôi hoàn toàn chịu trách nhiệm với Bộ công an."
                      />
                    </Box>
                  )}
                  <div className={classes.groupButtonSubmit}>
                    <div className={classes.buttonGroup}>
                      <Button
                        style={{
                          ...(isMobile && { maxWidth: 90 }),
                          marginRight: '10px',
                          textTranform: 'none !important'
                        }}
                        onClick={handleClose}
                        className="btn-main btn-plain mx-3"
                        color="primary"
                        size="large"
                        variant="contained"
                      >
                        Thoát
                      </Button>
                      <Button
                        style={{
                          ...(isMobile && { maxWidth: 120 }),
                          marginRight: '10px',
                          textTranform: 'none !important'
                        }}
                        className="btn-main mx-3"
                        color="primary"
                        size="large"
                        disabled={tabValue === 2 && isTransmit && !isCommitmentChecked}
                        type="submit"
                        variant="contained"
                      >
                        Lưu lại
                      </Button>
                      {statusCreate === STATUS_API.PENDING && (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      )}
                    </div>
                  </div>
                </Box>
              </form>
            )}
          </Formik>
        </div>
      </CustomDialog>
    </>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  appBar: {
    backgroundColor: 'transparent',
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none',
    marginBottom: 4
  },
  tabs: {
    backgroundColor: 'transparent',
    '& .MuiTab-root': {
      textTransform: 'none',
      fontSize: '1rem',
      minHeight: 48
    },
    '& .MuiTabs-indicator': {
      backgroundColor: theme.palette.primary.main
    }
  },
  groupButtonSubmit: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15px',
    position: 'relative',

    '& .left-button': {
      display: 'flex'
    }
  },
  commitmentBox: {
    marginBottom: theme.spacing(2),
    marginLeft: '-9px',
    '& .MuiFormControlLabel-root': {
      alignItems: 'center',
      margin: 0
    },
    '& .MuiCheckbox-root': {
      padding: 9,
      marginRight: theme.spacing(1)
    },
    '& .MuiFormControlLabel-label': {
      fontSize: '14px',
      lineHeight: 1.4,
      color: 'rgba(0, 0, 0, 0.87)'
    }
  },
  buttonGroup: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  wrapper: {
    position: 'relative'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  customOutline: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '1px',
      borderColor: 'rgba(31, 31, 31, 0.14)',
      borderRadius: '4px'
    }
  },
  switchContainer: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    right: 0
  },
  switchLabel: {
    marginRight: '10px',
    marginBottom: '0 !important',
    fontSize: '14px',
    fontWeight: 500,
    color: 'rgba(0, 0, 0, 0.87)'
  },
  sensorHint: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#888',
    fontSize: '12px',
    fontStyle: 'italic',
    minHeight: 40,
    marginTop: theme.spacing(1)
  },
  fuelSensorPanel: {
    border: '1px solid rgba(31, 31, 31, 0.12)',
    borderRadius: 8,
    padding: theme.spacing(2),
    backgroundColor: '#fff'
  },
  fuelSensorTitle: {
    fontSize: '15px',
    fontWeight: 600,
    color: 'rgba(0, 0, 0, 0.87)',
    marginBottom: theme.spacing(2)
  },
  fuelCalibrationRow: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr) auto',
    gap: theme.spacing(1.5),
    alignItems: 'center',
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  fuelCalibrationInput: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#fff'
    }
  },
  removeCalibrationButton: {
    color: '#9e9e9e',
    padding: 6,
    [theme.breakpoints.down('sm')]: {
      justifySelf: 'flex-end'
    }
  },
  addCalibrationButton: {
    borderStyle: 'dashed',
    textTransform: 'none',
    fontWeight: 600,
    color: 'rgba(0, 0, 0, 0.72)',
    borderColor: 'rgba(31, 31, 31, 0.18)',
    padding: theme.spacing(1.25),
    '&:hover': {
      borderStyle: 'dashed',
      borderColor: theme.palette.primary.main,
      backgroundColor: 'rgba(0, 0, 0, 0.02)'
    }
  },
  emptyTabText: {
    padding: theme.spacing(2, 0),
    textAlign: 'center'
  },
  customSwitchContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    position: 'relative'
  },

  switchText: {
    fontSize: '11px',
    fontWeight: 600,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 2,
    pointerEvents: 'none',
    userSelect: 'none',
    width: '50%',
    textAlign: 'center'
  },

  switchTextOff: {
    left: 0,
    color: '#fff'
  },

  switchTextOn: {
    right: 0,
    color: '#fff'
  },

  customSwitchRoot: {
    width: 48,
    height: 24,
    padding: 0
  },

  customSwitchBase: {
    padding: 2,
    transition: 'transform 0.3s ease',
    '&.Mui-checked': {
      transform: 'translateX(24px)',
      '& + $customSwitchTrack': {
        backgroundColor: '#52d869',
        opacity: 1
      }
    }
  },

  customSwitchThumb: {
    width: 20,
    height: 20,
    borderRadius: 4,
    backgroundColor: '#fff',
    boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
  },

  customSwitchTrack: {
    borderRadius: 4,
    backgroundColor: '#ccc',
    opacity: 1,
    transition: 'background-color 0.3s'
  }
}));

export default React.memo(EditVersionModal);
